import create from 'zustand';
import { IGiftCardExtendPackage, IGiftCardPackage } from '@root/types/package';

export interface IState {
  selectedPackage: IGiftCardPackage | null;
  selectExtendPackage: IGiftCardExtendPackage | null;
  setSelectedPackage: (v: IGiftCardPackage | null) => void;
  setSelectExtendPackages: (v: IGiftCardExtendPackage | null) => void;
  resetInitData: () => void;
}

const useGiftCard = create<IState>((set) => ({
  selectedPackage: null,
  selectExtendPackage: null,
  setSelectExtendPackages: (selectExtendPackage) => {
    return set(() => {
      return {
        selectExtendPackage,
      };
    });
  },
  setSelectedPackage: (selectedPackage) => {
    return set(() => {
      return {
        selectedPackage,
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        selectedPackage: null,
        selectExtendPackage: null,
      };
    });
  },
}));

export default useGiftCard;
